/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Currency } from '@app/settings/currencies/currency.model';
import { HttpResponse, Logger } from '@app/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { ApiQuery } from '@app/core/http/api-query';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { Model } from '@app/shared/models/model.model';

const log = new Logger('CurrenciesService');

@Injectable({
  providedIn: 'root',
})
export class CurrenciesService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    log.debug('index');
    return this.http.get('v1/currencies', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((currency: any) => {
          return new Currency().deserialize(currency);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/currencies/' + id);
  }

  store(currency: Currency): Observable<Currency> {
    return this.http.post('v1/currencies', currency).pipe(
      map((response: HttpResponse) => {
        return new Currency().deserialize(response.data);
      })
    );
  }

  update(currency: Currency): Observable<Currency> {
    return this.http.put('v1/currencies/' + currency.id, currency).pipe(
      map((response: HttpResponse) => {
        return new Currency().deserialize(response.data);
      })
    );
  }

  show(id: number): Observable<Model> {
    return this.http.get('v1/currencies/' + id).pipe(
      map((response: HttpResponse) => {
        return new Currency().deserialize(response.data);
      })
    );
  }

  updateRates(): Observable<HttpResponse> {
    return this.http.get('v1/currencies/update_rates').pipe(
      map((response: HttpResponse) => {
        return response;
      })
    );
  }
}
